<div class="modal-footer">
    <button type="button"
        class="btn btn-secondary"
        data-dismiss="modal"
        (click)="dismiss()">
        {{ closeBtnText }}
    </button>

    <button *ngIf="showConfirmBtn"
        type="button"
        class="btn btn-primary"
        title="{{title}}"
        [disabled]="disabledConfirmBtn"
        (click)="confirm()">
        {{ confirmBtnText }}
    </button>

    <ng-content></ng-content>
</div>